module.exports = __webpack_public_path__ + "media/images/social/xing-5f329b4518f8a8251eddf89b4d4066ed.png";